import { render, staticRenderFns } from "./ProposalFilters.vue?vue&type=template&id=153f5904&"
import script from "./ProposalFilters.vue?vue&type=script&lang=js&"
export * from "./ProposalFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports